module.exports = __webpack_public_path__ + "media/images/lb/029-4c41d636c1628f800e06f6764edd4981.svg";